import { Text, Icon, Stack } from '@fluentui/react';
import { Image, ImageFit } from '@fluentui/react/lib/Image';
import { Jugador } from '../../system/Jugador/Jugador';
import SystemClient from '../../system/SystemClient';

export const JugadorCardForConfeccionOffline = ({
  jugador,
  system,
  deleteJugador,
  disabledApparience,
  suspendedApparience,
  inactiveApparience,
}: {
  jugador: Jugador;
  system: SystemClient;
  deleteJugador: (j: Jugador) => void;
  disabledApparience: boolean;
  suspendedApparience: boolean;
  inactiveApparience?: boolean;
}) => {
  const imgStackStyles = {
    root: {
      marginRight: '15px',
    },
  };

  return (
    <>
      <div className="ms-Grid-col ms-sm10 mt-2">
        <div
          className="ms-Grid bg-white-h100 ms-depth-4"
          style={{ backgroundColor: suspendedApparience ? '#FFDBDB' : disabledApparience ? '#FFFFF0' : '' }}
        >
          <div className={'ms-Grid-row mt-1'} style={{ padding: '3px', margin: '0.2rem' }}>
            <Stack horizontal>
              <Stack.Item styles={imgStackStyles}>
                <Image
                  src={'/img/persona_default.jpg'}
                  imageFit={ImageFit.cover}
                  maximizeFrame
                  className="player-card-img"
                  styles={{
                    root: {
                      margin: '0 auto',
                      borderRadius: '50%',
                      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
                    },
                  }}
                />
              </Stack.Item>

              <Stack.Item grow>
                <Text variant="mediumPlus" className="bold" block>
                  {jugador.getApellido()}, {jugador.getNombre()}
                </Text>
                {jugador.getDocumentoNumero() && (
                  <>
                    <Text variant="small" className="secondary-text">
                      {+jugador.getDtiid() === 1 ? 'DNI: ' : 'Pasaporte: '}
                    </Text>{' '}
                    <Text variant="small" className="secondary-text">
                      {jugador.getDocumentoNumero()}
                    </Text>
                  </>
                )}
              </Stack.Item>
              <Stack.Item>
                <Icon
                  iconName="Cancel"
                  className="remove-item-cross clickable"
                  onClick={() => {
                    deleteJugador(jugador);
                  }}
                ></Icon>
              </Stack.Item>
            </Stack>
          </div>
        </div>
      </div>
    </>
  );
};
